import { TTemporalDataResponseSerie } from "@/components/ui/chart/types/temporal-chart-series.type";
import {
  ICalendarHeatmapXAxisAdapter,
  ICommonAxisAdapterOption,
} from "@/utils/chart/adapters/types/common-adapter.type";
import $date from "@/utils/date";
import { TLocalDate } from "@/utils/time";

export interface ICalendarHeatmapXAxisAdapterOptions extends ICommonAxisAdapterOption {
  xAxisMonthTickFormatter: (date: TLocalDate) => string;
}

export function CalendarHeatmapXAxisAdapter<KIND extends string>(
  opts: Partial<ICalendarHeatmapXAxisAdapterOptions> = {},
): ICalendarHeatmapXAxisAdapter<KIND> {
  return {
    adapt(serie: TTemporalDataResponseSerie<KIND>): Highcharts.XAxisOptions {
      const weekDates: Array<TLocalDate | undefined> = [];

      const maybeFirstPoint = serie.value[0];

      if (maybeFirstPoint) {
        const firstWeekDay = $date.getDateWeekDay(maybeFirstPoint.date);
        // if first weekday is not monday, add to weekDates
        if (firstWeekDay !== 0) weekDates.push(maybeFirstPoint.date);
      }

      const mondays = serie.value.filter((point) => $date.getDateWeekDay(point.date) === 0);
      mondays.forEach((monday) => {
        const isMonthAlreadyCategorized = weekDates.some((d) => {
          if (!d) return false;
          return (
            $date.getDateMonth(d) === $date.getDateMonth(monday.date) &&
            $date.getDateYear(d) === $date.getDateYear(monday.date)
          );
        });
        weekDates.push(isMonthAlreadyCategorized ? undefined : monday.date);
      });

      const datesCategories = weekDates.map((d) => (d ? (opts.xAxisMonthTickFormatter?.(d) ?? d) : ""));

      return {
        categories: datesCategories,
        opposite: opts.opposite,
        lineWidth: 0,
        tickInterval: 1,
        tickWidth: 0,
        labels: {
          step: 1,
          rotation: 320,
        },
      };
    },
  };
}
